<template>
  <nav class="globalNavWrap">
    <ul class="globalNav">
      <li class="icon-reserve">
        <IconButton
          label="予約・申込"
          icon="reserve-white"
          @click-btn="
            $store.dispatch('moveLimitedPage', '/mypage/document_request/list')
          "
        />
      </li>
      <li class="icon-heart">
        <IconButton
          label="お気に入り"
          icon="heart-white"
          @click-btn="
            $store.dispatch('moveLimitedPage', '/mypage/bookmark/list')
          "
        />
      </li>
      <li class="icon-search-thick">
        <IconButton
          label="検索"
          icon="search-thick-white"
          @click-btn="$store.dispatch('showSearchModal')"
        />
      </li>
      <li class="icon-book">
        <IconButton
          label="イベント"
          icon="calendar-white"
          @click-btn="$router.push('/events/list')"
        />
      </li>
      <li class="icon-user">
        <IconButton
          label="マイページ"
          icon="user-white"
          @click-btn="$store.dispatch('moveLimitedPage', '/mypage')"
        />
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import IconButton from '@/components/elements/IconButton.vue'

export default {
  name: 'GlobalNav',

  components: {
    IconButton
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.globalNav {
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  width: 100%;
  // height: 55px;
  // padding-bottom: 10px;
  height: calc(55px + env(safe-area-inset-bottom));
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background-color: var.$color-main;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.08);
  transition: height 0.2s ease, padding 0.2s ease;

  @include mixins.media() {
    display: none;
  }

  > li {
    flex-basis: 20%;
    flex-grow: 1;
  }

  ::v-deep(.iconButton_label) {
    color: #fff;
  }

  ::v-deep(.icon-menu) .iconButton_label {
    margin-top: 9px;
  }

  ::v-deep(.icon-book) .iconButton_label {
    margin-top: 6px;
  }
}
</style>
